export const PACKAGE_MANAGER_OPTIONS = [
  { label: "Cabal", value: "CABAL" },
  { label: "Cargo", value: "CARGO" },
  { label: "Composer", value: "COMPOSER" },
  { label: "Conan", value: "CONAN" },
  { label: "CRAN", value: "CRAN" },
  { label: "Erlang", value: "ERLANG" },
  { label: "Go", value: "GO" },
  { label: "Maven", value: "MAVEN" },
  { label: "npm", value: "NPM" },
  { label: "NuGet", value: "NUGET" },
  { label: "pip", value: "PIP" },
  { label: "Pub", value: "PUB" },
  { label: "RubyGems", value: "GEM" },
  { label: "SwiftPM", value: "SWIFT" },
];
